import { ComponentProps } from '@episerver/spa-core/EpiComponent';
import BusinessPromoVideoBlockData from 'app/Models/Content/BusinessPromoVideoBlockData';
import React, { useState } from 'react';
import useFadeIn from 'app/Components/Shared/UseFadeIn';
import BackgroundVideo from 'app/Components/Page/TVLobbyPage/BackgroundVideo';
import { getVideoLink } from 'app/utilities/ImageProps';
import Config from '../../../Config';

const BusinessPromoVideoBlock = ({ data, context }: ComponentProps<BusinessPromoVideoBlockData>) => {

  const { ref, fadeClass } = useFadeIn();
  const posterLink = Config.epiBaseUrl + data.posterImage.value?.url;
  const isDisplayControl = data.isDisplayControl?.value;
  const iconControlImage = Config.epiBaseUrl + data.iconControlImage?.value?.url;

  return (
    <div className='BusinessPromoVideoBlock'>
      <div ref={ref} className={`BusinessPromoVideoBlock__content ${fadeClass}`}>
        <h3 className='BusinessPromoVideoBlock__content__title'>{data.title.value}</h3>

        <p className='BusinessPromoVideoBlock__content__description'>{data.description.value}</p>

        <div className='BusinessPromoVideoBlock__content__link'>
          <a className='BusinessPromoVideoBlock__content__link__button' href={data.buttonLink.value}>
            {data.buttonLinkTitle.value}
          </a>
        </div>
      </div>
      <div className='BusinessPromoVideoBlock__video-container'>
        <div className='BusinessPromoVideoBlock__video-container__video'>
          <BackgroundVideo
            videoUrl={getVideoLink(data.videoLink, context)}
            posterUrl={posterLink}
            displayControl={isDisplayControl}
            iconControlImage={iconControlImage}
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessPromoVideoBlock;
